<script>
import { Tweenable } from 'shifty'

export default {
  props: {
    value: { type: Number, required: true },
  },
  data () {
    return {
      current: 0,
    }
  },
  computed: {
    output () {
      return parseInt(this.current)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.reset()

        const _this = this
        this.tween = new Tweenable()
        return this.tween.tween({
          from: { current: this.current },
          to: { current: this.value },
          easing: { current: 'easeOutQuart' },
          duration: 3000,
          step: (state) => {
            _this.current = state.current
          }
        })
      }
    }
  },
  methods: {
    reset () {
      if (!this.tween) return
      if (this.tween.isPlaying) {
        this.tween.stop()
      }

      return this.tween.dispose()
    }
  },
  render (create) {
    return create('span', this.output)
  }
}
</script>